import { Outlet, useLocation } from 'react-router-dom'
import TopBar from './TopBar'
import BottomNav from './BottomNav'

export default function AppLayout() {
  const location = useLocation()

  // Tampilkan menu button hanya di dashboard
  const showMenu = location.pathname === '/admin/dashboard'

  return (
    <div className="min-h-screen bg-iswara-gradient flex flex-col">
      <TopBar showMenu={showMenu} />
      <main className="flex-1 pt-14 pb-20 px-4">
        <div className="max-w-2xl mx-auto">
          <Outlet />
        </div>
      </main>
      <BottomNav />
    </div>
  )
}
